module.exports = __webpack_public_path__ + "static/media/html5.6ee633d9.svg";